var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSellersIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 16,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#202124",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.3,
  d: "M3.291 14.043a.655.655 0 0 0 .81.478 22.1 22.1 0 0 1 11.79 0 .657.657 0 0 0 .81-.478l2.064-8.765a.648.648 0 0 0-.89-.744l-4.096 1.82a.655.655 0 0 1-.833-.274l-2.38-4.29a.647.647 0 0 0-1.132 0l-2.38 4.29a.656.656 0 0 1-.833.275L2.126 4.534a.647.647 0 0 0-.89.744z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#202124",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.3,
  d: "M7.41 11.267a24 24 0 0 1 5.18 0"
})));
export default SvgSellersIcon;